import { BiRocket } from 'react-icons/bi';
import LoadingIndicator from '../../components/LoadingIndicator';

import Modal from '../../components/modals/Modal';
import {
  useSaveDashboard,
  useDashboardFormData,
} from './DashboardViewPageState';

export default function DashUnpublishModal({
  openPublish,
  setOpenPublish,
}: {
  openPublish?: boolean;
  setOpenPublish: (v: boolean) => void;
}) {
  // NOTE: outdated architecture, please refer [API api] folder structure
  const [saving, { saveDashboard }] = useSaveDashboard();

  const [values, setValues] = useDashboardFormData();

  return (
    <Modal open={openPublish}>
      <div className='flex flex-col gap-2'>
        <div className='text-xl font-bold'>Remove dashboard from Community</div>
        <div className='text-sm opacity-70'>
          Unpublishing this dashboard will remove it from the Community hub and
          prevent people from finding and using this dashboard
          <br />
          <br />
        </div>
      </div>
      <div className='flex flex-col gap-3'>
        <div className='flex gap-2 items-center'>
          <button
            className='btn gap-3 btn-error font-bold text-white'
            onClick={async () => {
              const nValues = {
                ...values,
                access: 'private',
              };
              const success = await saveDashboard(nValues);

              if (success) {
                setValues(nValues);
                setOpenPublish(false);
              }
            }}
          >
            <BiRocket size='1.1rem' />
            Unpublish
          </button>

          <button
            className='btn btn-ghost'
            style={{ border: '1px solid #aaaaaa' }}
            onClick={() => {
              setOpenPublish(false);
            }}
          >
            Cancel
          </button>
          {saving && <LoadingIndicator />}
        </div>
      </div>
    </Modal>
  );
}
